import { Link } from 'react-router-dom';
import { type VerifyCertificatePageData, longDate } from '@astrologermatch/shared';
import { SITE_NAME } from '../components/Layout.js';
import { useSeo } from '../lib/seo.js';
import { useSettings } from '../lib/state.js';

// Ported from prototype/src/pages/VerifyPage.jsx (brief §3: valid/not found, astrologer link,
// issue date, rating on the issue date, rating today).

export function VerifyPage({ data }: { data: VerifyCertificatePageData }) {
  const settings = useSettings();
  useSeo({
    title: `Verify certificate ${data.certificateNumber} | ${SITE_NAME}`,
    description: 'Check whether an AstrologerMatch rating certificate is genuine.',
    canonical: `${settings.siteUrl}/verify/${encodeURIComponent(data.certificateNumber)}`,
    robots: 'noindex,follow',
  });
  const c = data.certificate;
  return (
    <div className="wrap page-pad">
      <div className="card review-card">
        {data.found && c ? (
          <>
            <div className="big-check" aria-hidden="true">
              ✓
            </div>
            <h1 className="h2 center">Valid certificate</h1>
            <table className="table mt16">
              <tbody>
                <tr>
                  <th scope="row" className="muted">
                    Certificate ID
                  </th>
                  <td>
                    <code>{data.certificateNumber}</code>
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="muted">
                    Astrologer
                  </th>
                  <td>
                    {c.astrologerSlug ? (
                      <Link to={`/astrologers/${c.astrologerSlug}`}>{c.astrologerName}</Link>
                    ) : (
                      c.astrologerName
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="muted">
                    Issued on
                  </th>
                  <td>{longDate(new Date(c.issuedAt))}</td>
                </tr>
                <tr>
                  <th scope="row" className="muted">
                    Rating on that date
                  </th>
                  <td>
                    {c.ratingSnapshot}★ from {c.reviewCountSnapshot} reviews
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="muted">
                    Rating today
                  </th>
                  <td>
                    {c.reviewCountToday > 0
                      ? `${String(c.ratingToday)}★ from ${String(c.reviewCountToday)} reviews`
                      : 'No reviews currently shown'}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
          <>
            <h1 className="h2">Certificate not found</h1>
            <p className="muted">
              No certificate matches <code>{data.certificateNumber}</code>. Check the ID printed on
              the certificate.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
